module.exports = __webpack_public_path__ + "static/media/training.351e18b5.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/training.jpeg
// module id = 1601
// module chunks = 0